
export const name = 'customer-api-config'
export const api = {
  customer: {
    list: `/api/v2/agent/addressee/page`, // get
    detail: `/api/v2/agent/addressee/info`, // get
    delete: `/api/v2/agent/merchant/delete` // delete
  },
  address: {
    addOrEdit: `/api/v2/agent/addressee/add-update-addressee-batch`, // post
    getAddressDetail: `/api/v2/agent/addressee/addressee-info` // get
  },
  smart: {
    smartTitle: `/api/v2/agent/invoice/titleMatch` // get
  },
  wechat: {
    getOffiaccountSignature: `/api/v2/agent/user/account/signature` // get
  },
  noteLookProof: {
    getProofInfo: '/api/v2/agent/sendSms/result/proof', // get查询样张详细信息
    sendEmail: '/api/v2/agent/sendSms/result/email', //  get 发送邮箱接口
    getPdfUrl: `/api/v2/agent/sendSms/result/urlpdf` // get 发送请求获取到pdf路径
  },
  extendField: {
    getExtendFieldList: `/api/v2/bud/explain/page`, // post 查询扩展字段列表
    setExtendField: `/api/v2/bud/explain/update`, // post 更新扩展字段
    getExtendField: `/api/v2/bud/explain/mobile/query`, // post 查询扩展字段规则
    getNotAuthExtendField: `/api/v2/bud/explain/mobile/queryAudit`, // post 查询扩展字段规则 (不鉴权)
    resetConfig: `/api/v2/agent/extenconfig/extenConfig/reset `, // post 重置扩展字段

    setWaitExtendById: `/api/v2/agent/wait-invoice/update`, // 结算单 / 待开
    setOutputExtendById: `/api/v2/agent/invoice/update`, // 销项发票池
    setEntryExtendById: `/api/v2/agent/purchaser/invoice/update`, // 增
    setEntryNoExtendById: `/api/v2/agent/purchaser/we-chat/non-vat/update`, // 非增
    setAbnormalInvoiceById: `/api/v2/agent/exceptionInvoice/update` // 非增
  }
}
